import { FC } from 'react';
import { Button } from '@new/common/ui/Button/Button';

interface PlanFooterBarProps {
  onSave: () => void;
  saving: boolean;
  disabled?: boolean;
}

export const PlanFooterBar: FC<PlanFooterBarProps> = ({ onSave, saving, disabled }) => (
  <div className="sticky bottom-4 z-30 flex flex-col items-start justify-between gap-3 rounded-xl border border-(--neutral-black-NB200) bg-(--neutral-white-NW1000) p-4 sm:flex-row sm:items-center sm:p-5">
    <div className="flex flex-col gap-1">
      <span className="[font-size:var(--fs-p3)]! font-bold text-(--neutral-black-NB900)!">
        Happy with your plan?
      </span>
      <span className="[font-size:var(--fs-b4)]! text-(--neutral-black-NB700)!">
        Your course plan is almost ready. Once you&apos;ve chosen all the courses you&apos;d like to
        take, save your plan. Saving enrolls you in this degree.
      </span>
    </div>
    <Button
      variant="primary"
      className="w-full shrink-0 sm:w-auto"
      onClick={onSave}
      disabled={saving || disabled}
      text={saving ? 'Saving…' : 'Save plan'}
    />
  </div>
);
